import React from 'react';
import Relay from 'react-relay';
import { style } from 'glamor';

import { FormattedMessage } from 'react-intl';

import { FAMILY_STANDARD_BOLD } from 'depop/styles/typography';

import SimpleInfiniteScroll from 'depop/components/SimpleInfiniteScroll';

import { CommentList } from 'depop/components/comments';

class ProductComments extends React.Component {
  props: {
    productRelations: Object,
    disablePaging: boolean,
    relay: Object,
  };

  constructor(props) {
    super(props);
    this.state = {
      isCommentsFolded: true,
    };
  }

  loadMore = () => {
    this.props.relay.setVariables({
      count: this.props.relay.variables.count + 10,
    });
  };

  toggledCommentFold = () => {
    this.setState({ isCommentsFolded: !this.state.isCommentsFolded });
  };

  render() {
    const { productRelations, disablePaging } = this.props;
    const { isCommentsFolded } = this.state;
    const { comments, counters } = productRelations;
    const { numComments } = counters;

    const mappedComments = comments.edges.map(edge => edge.node);
    const commentsFoldAt = 3;

    const foldedComments = () => {
      return <CommentList comments={mappedComments.slice(0, commentsFoldAt)} />;
    };

    const fullComments = () => {
      return (
        <SimpleInfiniteScroll
          loadMore={this.loadMore}
          disablePaging={disablePaging}
          hasMore={comments.pageInfo.hasNextPage}>
          <CommentList comments={mappedComments} />
        </SimpleInfiniteScroll>
      );
    };

    if (numComments < 1) {
      return null;
    }

    if (numComments < 4) {
      return (
        <div
          {...style({
            appearance: 'none',
            padding: '0',
            border: '0',
            background: 'none',
            fontSize: 14,
            fontWeight: 'bold',
            marginBottom: '1em',
          })}>
          {fullComments()}
        </div>
      );
    }

    return (
      <div>
        {isCommentsFolded ? foldedComments() : fullComments()}
        {numComments &&
          <button
            {...style({
              appearance: 'none',
              padding: '0',
              border: '0',
              background: 'none',
              fontSize: 14,
              fontFamily: FAMILY_STANDARD_BOLD,
              fontWeight: 'bold',
              marginTop: '.5em',
              marginBottom: '1em',
            })}
            onClick={this.toggledCommentFold}>
            {isCommentsFolded
              ? <FormattedMessage
                  id="ProductComments.showMoreComments"
                  description="Button to show all comments"
                  defaultMessage={`{count, plural,
              =0 {0 comments}
              one {1 comment}
              other {Show all {count} comments...}
            }`}
                  values={{
                    count: counters.numComments,
                  }}
                />
              : <FormattedMessage
                  id="ProductComments.collapseComments"
                  description="Button to show fewer comments "
                  defaultMessage="Show fewer comments"
                />}
          </button>}
      </div>
    );
  }
}

export default Relay.createContainer(ProductComments, {
  initialVariables: {
    count: 3,
  },
  fragments: {
    productRelations: () => Relay.QL`
      fragment on ProductRelations {
        counters {
          numComments
        }
        comments(first: $count) {
          edges {
            node {
              ${CommentList.getFragment('comments')}
            }
          }
          pageInfo {
            hasNextPage
          }
        }
      }
    `,
  },
});



// WEBPACK FOOTER //
// ../src/client/apps/shops/components/ProductComments.js